<template>
  <div class="space-y-5 animate-fade-in">
    <header>
      <h1 class="text-2xl font-semibold text-white">Spotter Criteria</h1>
      <p class="text-sm text-slate-400 mt-1">
        Risk rules used by Lookout Spotter to prioritize supply-chain heads-ups.
      </p>
    </header>

    <section class="panel-neo panel-neo--glassier rounded-2xl p-4">
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead class="text-xs uppercase tracking-wide text-slate-400 border-b border-slate-700/70">
            <tr>
              <th class="text-left py-2 pr-3">Signal</th>
              <th class="text-left py-2 pr-3">Priority</th>
              <th class="text-left py-2 pr-3">How It Is Calculated</th>
              <th class="text-left py-2">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.signal" class="border-b border-slate-800/60 text-slate-200">
              <td class="py-2 pr-3 font-medium text-white">{{ row.signal }}</td>
              <td class="py-2 pr-3">{{ row.priority }}</td>
              <td class="py-2 pr-3 text-slate-300">{{ row.measurement }}</td>
              <td class="py-2">
                <span :class="row.active ? 'text-emerald-300' : 'text-slate-500'">
                  {{ row.active ? 'Reporting' : 'Planned' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
const rows = [
  {
    signal: 'Dispatch gap',
    priority: 'High',
    measurement: 'Active checkouts with 0 outbound legs.',
    active: true,
  },
  {
    signal: 'Maintenance holding inventory',
    priority: 'FYI',
    measurement: 'Units in Maintenance status.',
    active: true,
  },
  {
    signal: 'Returns overdue',
    priority: 'Medium',
    measurement: 'Return units not in transit by return date.',
    active: false,
  },
  {
    signal: 'Watchlist units',
    priority: 'FYI',
    measurement: 'Active Watchlist checkouts.',
    active: false,
  },
  {
    signal: 'Watchlist dispatch gap',
    priority: 'Critical',
    measurement: 'Active Watchlist checkouts with 0 outbound legs.',
    active: false,
  },
  {
    signal: 'Watchlist delivery late',
    priority: 'Critical',
    measurement: 'Active Watchlist checkouts not delivered by delivery date.',
    active: false,
  },
  {
    signal: 'Dispatch late',
    priority: 'High',
    measurement: 'Active checkouts not delivered by delivery date.',
    active: false,
  },
]
</script>
